// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IPhotoDownloadUrl {
	id: string | undefined;

	url: string | undefined;

	$type?: string | undefined;
}
export class PhotoDownloadUrl {
	constructor(data?: IPhotoDownloadUrl) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	id: string | undefined;

	url: string | undefined;

	static $type: string = "CoreApi.Controllers.PhotoDownloadUrl, ";
	$type?: string | undefined = PhotoDownloadUrl.$type;
}

